import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepTravelDelay = (state) => state.get('stepTravelDelay');

const makeSelectStepTravelDelay = () => createSelector(
  selectStepTravelDelay,
  (stepTravelDelayState) => ({
    // travel Delay
    travelDelay: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'travelDelay']),
      ''
    ),

    detailsRegardingYourTripDelay: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'detailsRegardingYourTripDelay']),
      ''
    ),

    didTheDelayOccurDuringDeparture: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'didTheDelayOccurDuringDeparture']),
      ''
    ),

    didTheDelayOccurDuringArrival: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'didTheDelayOccurDuringArrival']),
      ''
    ),

    dateYouWereDueToDepart: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'dateYouWereDueToDepart']),
      ''
    ),

    timeYouWereDueToDepart: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'timeYouWereDueToDepart']),
      ''
    ),

    dateTripWasDelayed: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'dateTripWasDelayed']),
      ''
    ),

    dateDelayEnded: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'dateDelayEnded']),
      ''
    ),

    dateYouActuallyDeparted: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'dateYouActuallyDeparted']),
      ''
    ),

    timeYouActuallyDeparted: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'timeYouActuallyDeparted']),
      ''
    ),

    delayInformationItems: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'delayInformationItems']) && stepTravelDelayState.getIn(['form', 'delayInformationItems']).toJS(),
      ''
    ),

    scheduledDateOfDeparture: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledDateOfDeparture']),
      ''
    ),

    scheduledTimeOfDeparture: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledTimeOfDeparture']),
      ''
    ),

    actualDateOfDeparture: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualDateOfDeparture']),
      ''
    ),

    actualTimeOfDeparture: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualTimeOfDeparture']),
      ''
    ),

    scheduledDateOfArrival: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledDateOfArrival']),
      ''
    ),

    scheduledTimeOfArrival: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledTimeOfArrival']),
      ''
    ),

    actualDateOfArrival: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualDateOfArrival']),
      ''
    ),

    actualTimeOfArrival: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualTimeOfArrival']),
      ''
    ),

    reasonsForDelay: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'reasonsForDelay']),
      ''
    ),

    // Missed Connection
    missedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'missedConnection']),
      ''
    ),

    scheduledDateOfDepartureForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledDateOfDepartureForMissedConnection']),
      ''
    ),

    scheduledTimeOfDepartureForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledTimeOfDepartureForMissedConnection']),
      ''
    ),

    scheduledDateOfArrivalForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledDateOfArrivalForMissedConnection']),
      ''
    ),

    scheduledTimeOfArrivalForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'scheduledTimeOfArrivalForMissedConnection']),
      ''
    ),

    didTheDelayOccurDuringDepartureForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'didTheDelayOccurDuringDepartureForMissedConnection']),
      ''
    ),

    didTheDelayOccurDuringArrivalForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'didTheDelayOccurDuringArrivalForMissedConnection']),
      ''
    ),

    detailsRegardingYourMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'detailsRegardingYourMissedConnection']),
      ''
    ),

    reasonsForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'reasonsForMissedConnection']),
      ''
    ),

    actualDateOfDeparturForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualDateOfDeparturForMissedConnection']),
      ''
    ),
    
    actualTimeOfDepartureForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualTimeOfDepartureForMissedConnection']),
      ''
    ),

    actualDateOfArrivalForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualDateOfArrivalForMissedConnection']),
      ''
    ),

    actualTimeOfArrivalForMissedConnection: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'actualTimeOfArrivalForMissedConnection']),
      ''
    ),

    missedConnectionInformationItems: mapWithDefault(
      stepTravelDelayState,
      () => stepTravelDelayState.getIn(['form', 'missedConnectionInformationItems']) && stepTravelDelayState.getIn(['form', 'missedConnectionInformationItems']).toJS(),
      ''
    ),

    companyNameLoss: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'currentAmountOfLoss']), ''),
    haveYouReceivedReimbursement: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(stepTravelDelayState, () => stepTravelDelayState.getIn(['form', 'enableTime']), null),
  })
);

const makeSelectStepTravelDelayErrors = () =>
  createSelector(selectStepTravelDelay, (state) => state.get('errors'));

export {
  makeSelectStepTravelDelay,
  makeSelectStepTravelDelayErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTravelDelay/selectors.js